import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import { ToastContainer, toast } from "react-toastify";

const SmeTransitionV2Master = () => {
  const history = useHistory();
  const [masterData, setMasterData] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [disableState, setDisableState] = useState(false);

  const emptyForm = {
    id: null,
    sr_no: "",
    section_name: "",
    task_name: "",
    description: "",
  };
  const [formData, setFormData] = useState({ ...emptyForm });

  useEffect(() => {
    loadMasterData();
  }, []);

  function loadMasterData() {
    clientmanageService.getTransitionV2Master().then((response) => {
      if (response && response.status === 200) {
        setMasterData(response.data.data);
      }
    });
  }

  function handleFormChange(field, value) {
    setFormData({ ...formData, [field]: value });
  }

  function handleAdd() {
    setFormData({ ...emptyForm });
    setShowAddModal(true);
  }

  function handleEdit(item) {
    setFormData({
      id: item.id,
      sr_no: item.sr_no,
      section_name: item.section_name,
      task_name: item.task_name,
      description: item.description || "",
    });
    setShowEditModal(true);
  }

  function submitAdd() {
    if (!formData.sr_no || !formData.section_name || !formData.task_name) {
      toast.error("Sr No, Section Name, and Task Name are required");
      return;
    }
    setDisableState(true);
    clientmanageService.addTransitionV2Master(formData).then((response) => {
      if (response && response.status === 200) {
        toast.success(response.data.message);
        setShowAddModal(false);
        loadMasterData();
      } else {
        toast.error("Something went wrong!");
      }
      setDisableState(false);
    });
  }

  function submitEdit() {
    if (!formData.sr_no || !formData.section_name || !formData.task_name) {
      toast.error("Sr No, Section Name, and Task Name are required");
      return;
    }
    setDisableState(true);
    clientmanageService
      .updateTransitionV2Master(formData)
      .then((response) => {
        if (response && response.status === 200) {
          toast.success(response.data.message);
          setShowEditModal(false);
          loadMasterData();
        } else {
          toast.error("Something went wrong!");
        }
        setDisableState(false);
      });
  }

  function handleDelete(id) {
    if (
      window.confirm(
        "This will not affect existing transitions. Are you sure you want to delete this item?"
      )
    ) {
      clientmanageService.deleteTransitionV2Master(id).then((response) => {
        if (response && response.status === 200) {
          toast.success(response.data.message);
          loadMasterData();
        } else {
          toast.error("Something went wrong!");
        }
      });
    }
  }

  const renderFormModal = (isEdit) => (
    <Modal
      isOpen={isEdit ? showEditModal : showAddModal}
      toggle={() => (isEdit ? setShowEditModal(false) : setShowAddModal(false))}
      size="lg"
    >
      <div className="modal-header">
        <h5 className="modal-title">
          {isEdit ? "Edit Master Item" : "Add Master Item"}
        </h5>
        <button
          type="button"
          className="close"
          onClick={() =>
            isEdit ? setShowEditModal(false) : setShowAddModal(false)
          }
        >
          <span>&times;</span>
        </button>
      </div>
      <ModalBody>
        <Row>
          <Col md="4">
            <FormGroup>
              <label className="form-control-label">Sr No</label>
              <Input
                type="number"
                value={formData.sr_no}
                onChange={(e) => handleFormChange("sr_no", e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="8">
            <FormGroup>
              <label className="form-control-label">Section Name</label>
              <Input
                type="text"
                value={formData.section_name}
                onChange={(e) =>
                  handleFormChange("section_name", e.target.value)
                }
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <FormGroup>
              <label className="form-control-label">Task Name</label>
              <Input
                type="text"
                value={formData.task_name}
                onChange={(e) => handleFormChange("task_name", e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <FormGroup>
              <label className="form-control-label">Description</label>
              <Input
                type="textarea"
                value={formData.description}
                onChange={(e) =>
                  handleFormChange("description", e.target.value)
                }
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={isEdit ? submitEdit : submitAdd}
          disabled={disableState}
        >
          {disableState ? "Saving..." : "Save"}
        </Button>
        <Button
          color="secondary"
          onClick={() =>
            isEdit ? setShowEditModal(false) : setShowAddModal(false)
          }
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <div className="row">
          <div className="col-xl-12">
            <Row className="align-items-center row">
              <Col xl="10">
                <Button
                  className="dash-button"
                  color="primary"
                  type="button"
                  onClick={handleAdd}
                >
                  + Add New Item
                </Button>{" "}
                <Button
                  className="dash-button"
                  color="secondary"
                  type="button"
                  onClick={() =>
                    history.push("/admin/sme-transition-v2")
                  }
                >
                  Back to List
                </Button>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xl="12">
                <Card className="shadow">
                  <CardHeader className="bg-transparent">
                    <Row className="align-items-center">
                      <div className="col">
                        <h4 className="text-uppercase text-muted ls-1 mb-1">
                          Master Checklist Items
                        </h4>
                      </div>
                    </Row>
                  </CardHeader>
                  <Table
                    className="align-items-center table-flush"
                    responsive
                  >
                    <thead className="thead-light">
                      <tr>
                        <th scope="col" className="whitespace">Sr No</th>
                        <th scope="col" className="whitespace">Section Name</th>
                        <th scope="col" className="whitespace">Task Name</th>
                        <th scope="col" className="whitespace">Description</th>
                        <th scope="col" className="whitespace">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {masterData && masterData.length > 0 ? (
                        masterData.map((item, i) => (
                          <tr
                            key={item.id}
                            className={
                              i % 2 === 0 ? "purple-row" : "orange-row"
                            }
                          >
                            <td className="whitespace">{item.sr_no}</td>
                            <td className="whitespace">{item.section_name}</td>
                            <td className="whitespace">{item.task_name}</td>
                            <td className="whitespace">
                              {item.description || "-"}
                            </td>
                            <td className="whitespace">
                              <Button
                                color="info"
                                size="sm"
                                onClick={() => handleEdit(item)}
                                title="Edit"
                              >
                                <i className="fas fa-edit"></i>
                              </Button>{" "}
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => handleDelete(item.id)}
                                title="Delete"
                              >
                                <i className="fas fa-trash"></i>
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6}>No Data Found!</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card>
              </Col>
            </Row>
          </div>
        </div>

        {renderFormModal(false)}
        {renderFormModal(true)}
      </Container>
    </>
  );
};

export default SmeTransitionV2Master;
